import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { deleteComp as deleteCompAPI } from 'services/apiComparable';

const useDeleteComp = () => {
  const queryClient = useQueryClient();
  const{isPending:isDeleting, isSuccess: isDeleted, mutate: deleteComp} = useMutation({
    mutationFn: deleteCompAPI,
    onSuccess:()=>{
        queryClient.invalidateQueries({queryKey:['compList']})
    },
    onError:(error)=>{
         console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })

  return{isDeleting, isDeleted, deleteComp}
}

export default useDeleteComp